import React, { Component } from 'react';
import ErrorPage from './ErrorPage'; // Adjust the path based on your file structure

class ErrorBoundary extends Component {
  state = {
    hasError: false,
  };

  static getDerivedStateFromError(error) {
    // Update state so the next render shows the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can log the error to an error reporting service
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
        console.log("error",this.state.hasError)
      // Render the ErrorPage component when an error occurs
      return <ErrorPage />;
    }

    // Render children if no error
    return this.props.children;
  }
}

export default ErrorBoundary;